import { ApiClient } from '../../../api';
import { NpiSourceEnum, ProcessNpiBodyDto } from '../../../dto/recs.dto';
import { AdSet } from '../../../entities/ad-set';
import { NpiSourceInterface } from '../../../interfaces/components/npi/npi-source.interface';
import { PublicNpi } from '../../../types';
import { Injectable } from '../../dependency-injection/decorators';

@Injectable()
export abstract class AbstractNpiSource implements NpiSourceInterface {
  public constructor (protected readonly apiClient: ApiClient) {
  }

  public abstract getType (): NpiSourceEnum;

  public supports (adSet: AdSet): boolean {
    return (adSet.getSettings().getNpiSources() ?? []).includes(this.getType());
  }

  public async detect (adSet: AdSet): Promise<PublicNpi[]> {
    const sourceNpiBody = await this.process(adSet);

    if (!sourceNpiBody) {
      return [];
    }

    if (sourceNpiBody.encryptedNpi || sourceNpiBody.aimId) {
      return this.apiClient.processNpi(sourceNpiBody, adSet.getId());
    }

    return [];
  }

  protected abstract process (adSet: AdSet): Promise<ProcessNpiBodyDto>;
}
